export default "__VITE_ASSET__8cf8fee7__"